"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponentThemes = require("../../_nextgen/packages/styled-component-themes");
var _index = _interopRequireDefault(require("./index.styled"));
var colors = _interopRequireWildcard(require("./index.themes"));
var _jsxRuntime = require("react/jsx-runtime");
const DividerLine = function (_ref) {
  let {
    spacing = "block",
    hideLine = false,
    className,
    enableDesignTab = false
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.DividerContainer, {
    className: className,
    $spacing: spacing,
    $enableDesignTab: enableDesignTab,
    "data-testid": "DividerLine",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Divider, {
      className: "divider",
      $hideLine: hideLine
    })
  });
};
var _default = exports.default = (0, _styledComponentThemes.withThemes)(DividerLine, colors);